import React, { memo, HTMLProps } from "react";
import { twMerge } from "tailwind-merge";
import classnames from "classnames";
import Element from "src/components/base/element";

interface IProps extends HTMLProps<HTMLDivElement> {
    className?: string;
    narrow?: boolean;
    children: React.ReactNode;
}

function LevelItem(props: IProps) {
    const { className, children, narrow, ...rest } = props;
    return (
        <Element
            {...rest}
            className={twMerge(
                "level-item",
                "items-center flex basis-auto grow-0 shrink-0 justify-center",
                "[&:not(:last-child)]:mb-0 [&:not(:last-child)]:mr-0",
                className,
                classnames({
                    "grow": !narrow,
                })
            )}
        >
            {children}
        </Element>
    );
}

export default memo(LevelItem);
